import React from "react";
import { Box } from "@mui/material";

export const initScheduleOptions = ({
  scheduleList
}) => {
  return scheduleList.map((p) => ({ label: p.name, value: p.id }));
};

export const parseMacCsv = (symbol, csvContent) => {
  const lines = csvContent.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  const formats = {
    colon: /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/,
    dash: /^([0-9A-Fa-f]{2}-){5}[0-9A-Fa-f]{2}$/,
    plain: /^[0-9A-Fa-f]{12}$/,
  };

  const regex = formats[symbol];
  if (!regex) return [];

  const result = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    // Skip csv header if present
    if (i === 0 && (line.toLowerCase().includes("mac") || line.toLowerCase().includes("address"))) {
      continue;
    }

    const [macRaw, descRaw = ""] = line.split(",");
    if (!macRaw) continue;

    const mac = macRaw.trim();
    const description = descRaw.trim();

    if (regex.test(mac)) {
      result.push({ macAddress: mac, description, vlan: "" });
    }
  }

  return result;
};
